/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".rootIsFixed_ffe4f500{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.content_ffe4f500{visibility:visible}\n"}]);
export const rootIsFixed = "rootIsFixed_ffe4f500";
export const content = "content_ffe4f500";